<style scoped="scoped" lang="scss">
.container {
  padding-left: 24px;
  padding-right: 24px;
  overflow: auto;
  // width: calc(100% - 40px);
  min-width: 500px;

  .title-info {
    width: 30%;
    min-width: 456px;
    display: flex;
    align-items: center;

    .item {
      flex: 1;
      display: flex;
      flex-direction: column;

      .title {
        height: 50%;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;

        .sign {
          position: static;
          width: 5px;
          height: 16px;
          left: 0px;
          top: 3px;
          flex: none;
          order: 0;
          flex-grow: 0;
          margin: 0px 12px 0 0;
        }

        .txt {
          font-size: 14px;
          font-family: Microsoft YaHei UI;
          color: #909399;
        }
      }

      .num {
        color: #606266;
        font-size: 20px;
        line-height: 20px;
        font-weight: bold;
        width: 100%;
        height: 30px;
        order: 0;
        flex-grow: 0;
        margin: 12px 0 0 18px;
      }
    }

    .color-blue {
      background: #419fff;
    }

    .color-green {
      background: #67c23a;
    }

    .color-red {
      background: #f56c6c;
    }

    .color-orange {
      background: #e6a23c;
    }
  }

  // 表格
  .table {
    width: calc(100% - 0px);
    margin-top: 12px;

    .main {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      padding: 5px;
      color: #909399;

      .item {
        width: 50%;
        padding: 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .label {
          width: 60%;
        }
      }
    }
  }
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt" getKey="rows"> </yi_curd_table>
    <div class="container">
      <div class="form">
        <el-form size="mini" :model="conditions" :inline="true">
          <el-form-item :label="$t('xuanzeyuefen')">
            <yi_time_input format="yyyy-MM" :type="'month'" :time.sync="conditions.planTime"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_cross_select :component="'web_base_equipment_list'" ref="selectEquipment" :max="1" :ids.sync="conditions.equipmentId"> </yi_cross_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="getCheckDaily" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="reset()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 头部信息 -->
      <div class="title-info">
        <!-- 当月点检单 -->
        <div class="item">
          <div class="title">
            <div class="sign color-blue"></div>
            <div class="txt">{{ $t('dangyuedianjiandan') }}</div>
          </div>
          <div class="num">
            {{ info.totalBill || '--' }}
          </div>
        </div>
        <!-- 点检合格 -->
        <div class="item">
          <div class="title">
            <div class="sign color-green"></div>
            <div class="txt">{{ $t('dianjianhege') }}</div>
          </div>
          <div class="num">
            {{ info.passBill || '--' }}
          </div>
        </div>
        <!-- 点检不合格 -->
        <div class="item">
          <div class="title">
            <div class="sign color-red"></div>
            <div class="txt">{{ $t('dianjianbuhege') }}</div>
          </div>
          <div class="num">
            {{ info.failBill || '--' }}
          </div>
        </div>
        <!-- 超期未点检 -->
        <div class="item">
          <div class="title">
            <div class="sign color-orange"></div>
            <div class="txt">{{ $t('chaoqiweidianjian') }}</div>
          </div>
          <div class="num">
            {{ info.expireBill || '--' }}
          </div>
        </div>
      </div>
      <div style="float: right; margin-top: 8px; margin-bottom: 8px;">
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportCheck()"> </el-button>
      </div>
      <!-- table -->
      <div class="table" style="margin-top: 8px;">
        <el-table @header-dragend="headerDragend" stripe max-height="600" :data="checkDaily.tableData" size="mini" border style="width: 100%" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }" v-loading="searchLoading">
          <el-table-column :label="$t(checkDaily.currentEquipment)" :show-overflow-tooltip="true">
            <el-table-column :label="$t('dianjianfenzu')" prop="group" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column :label="$t('dianjianneirong')" prop="content" :show-overflow-tooltip="true" width="300"></el-table-column>
            <el-table-column :label="$t('zhuyishixiang')" prop="attention" width="130" :show-overflow-tooltip="true"></el-table-column>
          </el-table-column>
          <el-table-column :label="checkDaily.currentDate">
            <el-table-column width="50" v-for="(item, index) in checkDaily.tableColumn" :key="index" :prop="item.prop" :sortable="item.sortable" :label="$t(item.label)" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <template v-if="scope.row[item.prop] === 0">
                  <span style="font-size: 18px;">×</span>
                </template>
                <template v-if="scope.row[item.prop] === 1">
                  <span style="font-size: 18px;">√</span>
                </template>
                <template v-if="scope.row[item.prop] === 2"> </template>
                <!-- 	<div style="font-size: 18px;">{{ scope.row[item.prop] === 0 ? '×' : '√' }}</div> -->
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_report_check_daily_list',
  data() {
    return {
      exportLoading: false,
      searchLoading: false,
      fildIds: '',
      timer: null,
      conditions: {
        equipmentId: '',
        planTime: 0
      },
      info: {
        totalBill: '', //当月点检单
        passBill: '', //点检合格
        failBill: '', //点检不合格
        expireBill: '' //超期未点检
      },
      checkDaily: {
        tableData: [],
        tableColumn: [],
        currentEquipment: this.$t('shebeimingcheng'),
        currentDate: ''
      },
      key: 0,
      show: true
    };
  },

  watch: {
    conditions: {
      handler(n) {
        if (n.equipmentId !== '') {
          this.checkDaily.currentEquipment = this.$t('shebeimingcheng') + ' ' + this.$refs['selectEquipment'].id_label[0];
        }
        if (n.planTime !== null && n.planTime) {
          this.checkDaily.currentDate = this.timestampToTime(n.planTime);
        } else {
          this.checkDaily.currentDate = '';
        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {},
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    // 导出
    exportCheck() {
      this.exportLoading = true;
      let requestParam = {
        ...this.conditions
        // orderBy: 'sort,startTime asc',
      };
      return this.http
        .get('/web/report/daily/check/export?' + this.qs.stringify(requestParam))
        .then(response => {
          let fildId = response.data;
          return this.http
            .get('/web/report/work/get', {
              params: {
                id: fildId
              }
            })
            .then(response => {
              this.fildIds = response.data.fileId;
              let status = response.data.status;
              if (status == 1) {
                this.getDownload();
                this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
                this.$message.success(this.$t(response.msg));
              } else if (status == -1) {
                this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
                this.$message.success(this.$t(response.msg));
              } else if (status == 0 || null) {
                this.timer = setInterval(() => {
                  this.getDownload();
                }, 1000);
              }
            })
            .finally(() => {
              this.exportLoading = false;
            });
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    getDownload() {
      console.log('this.fildIdthis.fildId', this.fildIds);
      return this.http.get('/web/customer/files/download?id=' + this.fildIds).then(res => {
        let baseUrl = res.data;
        if (res.data) {
          window.open(baseUrl);
        }
      });
    },
    // 日期转换
    timestampToTime(timestamp) {
      const date = new Date(timestamp);
      const Y = date.getFullYear() + '-';
      const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      return Y + M;
    },
    // 重置
    reset() {
      this.conditions = {
        equipmentId: null,
        planTime: 0
      };
      this.checkDaily.tableColumn = [];
      this.$refs['selectEquipment'].id_label[0] = '';
      this.info.totalBill = null;
      this.info.passBill = null;
      this.info.failBill = null;
      this.info.expireBill = null;
      this.checkDaily.tableData = [];
      this.show = false;
      setTimeout(() => {
        this.show = true;
      }, 0);
    },
    // 搜索
    getCheckDaily() {
      this.show = false;
      this.searchLoading = true;
      let requestParam = {
        ...this.conditions
      };
      return this.http
        .get('/web/report/daily/check?' + this.qs.stringify(requestParam))
        .then(response => {
          this.info.totalBill = response.data.extend.totalBill.length;
          this.info.passBill = response.data.extend.passBill.length;
          this.info.failBill = response.data.extend.failBill.length;
          this.info.expireBill = response.data.extend.expireBill.length;
          const rows = response.data.rows || [];
          this.checkDaily.tableColumn = [];
          this.checkDaily.tableData = [];
          if (rows.length > 0) {
            const item = rows[0];
            for (let i in item) {
              if (i === 'attention') {
                continue;
              }
              if (i === 'content') {
                continue;
              }
              if (i === 'group') {
                continue;
              }
              this.checkDaily.tableColumn.push({
                label: i,
                prop: i,
                sortable: false
              });
            }
            this.checkDaily.tableColumn.sort(this.sortProp);
            this.checkDaily.tableData = rows;
            console.log('aaaaaaa', this.checkDaily.tableColumn);
          }
          this.show = true;
        })
        .catch(error => {
          this.show = true;
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },
    // 排序
    sortProp(a, b) {
      return a.prop - b.prop;
    }
  }
};
</script>
